// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"send","clipPath":"url(#clip0_543_8119)"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M2 3.5L21.5 12L2 20.5L5 12L2 3.5Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M5 12L2 20.5L21.5 12L2 3.5L5 12ZM5 12H10","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const SendIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'send',
    ref,
    icon: element,
  },
));

SendIcon.displayName = 'SendIcon';

export default SendIcon;
